(() => {
  const TARGET_LABEL = 'Start with a Lab-Created Diamond';
  const VIEW_NAME = 'lab-diamond';

  const normalizeText = (value) =>
    (value || '').replace(/\s+/g, ' ').trim();

  const buildUrlWithView = (rawHref) => {
    const fallback = '/collections/all';
    const href = rawHref && rawHref !== '#' ? rawHref : fallback;
    try {
      const url = new URL(href, window.location.origin);
      url.searchParams.set('view', VIEW_NAME);
      return url.toString();
    } catch (error) {
      return href;
    }
  };

  const matchLabel = (el) => normalizeText(el?.textContent) === TARGET_LABEL;

  const updateLinks = () => {
    const links = Array.from(document.querySelectorAll('a'));
    links.filter(matchLabel).forEach((link) => {
      const targetHref = buildUrlWithView(link.getAttribute('href'));
      link.setAttribute('href', targetHref);
    });
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const link = target.closest('a');
    if (!link || !matchLabel(link)) return;
    event.preventDefault();
    window.location.href = buildUrlWithView(link.getAttribute('href'));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateLinks);
  } else {
    updateLinks();
  }
})();
